import React from 'react';
import dayjs from 'dayjs';
import { Typography } from 'antd';

import { useTranslation } from 'app/i18n-config';
import { config as appConfig } from 'app/config';
import { UserConfig } from 'app/models/user-config';
import { acceptTerms, Terms } from 'app/components/terms/terms';

import styles from './footer.module.scss';

interface Props {
  config: UserConfig | null;
}

export const Footer: React.FC<Props> = ({ config }) => {
  const { t } = useTranslation();

  const [showTerms, setShowTerms] = React.useState<boolean>(false);

  const year = React.useMemo(() => dayjs().year(), []);

  const handleShowTerms = React.useCallback(() => {
    setShowTerms(true);
  }, []);

  const handleAcceptTerms = React.useCallback(() => {
    setShowTerms(false);
    acceptTerms(config);
  }, [config]);

  return (
    <footer className={styles.footer}>
      <div>
        &copy; {year} {appConfig.name}{' '}
        {config?.termsContent && (
          <>
            | <Typography.Link onClick={handleShowTerms}>{t('footer.terms')}</Typography.Link>
          </>
        )}
      </div>
      <div className={styles.developer}>
        <a href="https://avakomp.lt/about-us" target="_blank" rel="noreferrer">
          Avakompas
        </a>{' '}
        |{' '}
        <a href="https://avakomp.lt/contactus" target="_blank" rel="noreferrer">
          B2B
        </a>
      </div>
      <Terms visible={showTerms} onAccept={handleAcceptTerms} />
    </footer>
  );
};
